module.exports = __webpack_public_path__ + "img/caas2-m@1.f793a24d.jpg";